module.exports = "<div [ngClass]=\"cssClass\" role=\"alert\" class=\"alert\">\n    <button (click)=\"fechar()\" type=\"button\" class=\"close\" aria-label=\"Fechar\">\n        <span aria-hidden=\"true\">&times;</span>\n    </button>\n\n    <h4 *ngIf=\"titulo\">{{titulo}}</h4>\n\n    <div [innerHTML]=\"texto\"></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/alert/alert.component.html
// module id = ./src/app/common/alert/alert.component.html
// module chunks = main